export default function CategoryRail({ categories, active, onSelect, loading, testPrefix }) {
  const items = [{ category_id: "", category_name: "All" }, ...categories];
  return (
    <aside className="w-[220px] shrink-0 border-r border-[#212738] overflow-y-auto xc-scroll py-3" data-testid={`${testPrefix}-categories`}>
      <div className="xc-label px-5 pb-2">Categories</div>
      {loading && <div className="px-5 text-sm text-slate-500">Loading…</div>}
      {!loading &&
        items.map((c) => (
          <button
            key={c.category_id || "all"}
            onClick={() => onSelect(c.category_id)}
            data-testid={`${testPrefix}-category-${c.category_id || "all"}`}
            className={`w-full text-left px-5 py-2 text-sm truncate transition-colors duration-150 ${
              active === c.category_id ? "text-white bg-[#1A1E2E] border-l-2 border-[#E50914]" : "text-slate-400 hover:text-white hover:bg-[#11141F] border-l-2 border-transparent"
            }`}
          >
            {c.category_name}
          </button>
        ))}
    </aside>
  );
}
